import { types } from 'mobx-state-tree';

const SizeGuide = types.model('SizeGuide', {
  contents: types.string,
  name: types.string
});

export default SizeGuide;
